import { PostgrestError } from "@supabase/postgrest-js";
import { ExternalToast, toast } from "sonner";

export function errorToast(
  error: { message?: string } | PostgrestError | Error | null,
  fallbackMessage?: string
) {
  const data: ExternalToast = {};
  if (error !== null || fallbackMessage !== undefined) {
    let description = fallbackMessage;
    if (!description && error) {
      const maybePostgrest = error as PostgrestError;
      const code = typeof maybePostgrest.code === "string" ? maybePostgrest.code : null;
      const message = (error.message ?? "").toLowerCase();
      const isRls =
        code === "42501" ||
        message.includes("row-level security") ||
        message.includes("row level security");
      description = isRls
        ? "You don't have permission to complete this action."
        : error.message;
    }
    data.description = description;
  }
  toast.error("Something went wrong", data);
}
